var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// x-date-picker-dropdown.ts
import { isMobile } from "@adornis/base/client/frontend-helpers/window-size.js";
import { ChemistryLitElement } from "@adornis/chemistry/chemistry-lit-element.js";
import { RXController } from "@adornis/chemistry/controllers/RXController.js";
import { css } from "@adornis/chemistry/directives/css.js";
import { injectAttributesOf } from "@adornis/chemistry/directives/inject-attributes.js";
import "@adornis/chemistry/elements/components/x-button.js";
import "@adornis/chemistry/elements/components/x-formfield-wrapper.js";
import { DesignSystem } from "@adornis/chemistry/elements/theming/design.js";
import { inputToken } from "@adornis/chemistry/elements/theming/input-token.js";
import { xComponents } from "@adornis/chemistry/elements/x-components.js";
import { intrinsicHeight } from "@adornis/chemistry/viewport.js";
import { XDialog } from "@adornis/dialog/x-dialog.js";
import { FormField } from "@adornis/formfield/form-field.js";
import "@adornis/forms/x-input.js";
import "@adornis/popover/x-dropdown.js";
import { findParentOf, getActiveElement } from "@adornis/popover/x-dropdown.js";
import { html, nothing } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { createRef, ref } from "lit/directives/ref.js";
import { DateTime } from "luxon";
import { fromEvent, merge, timer } from "rxjs";
import { delay, distinctUntilChanged, map, takeUntil } from "rxjs/operators";
import "./x-basic-date-picker.js";
import "./x-basic-date-picker.js";
import "./x-date-picker.js";
var XDatePickerDropdown = class extends FormField {
  constructor() {
    super();
    this.activated = false;
    this["end-year"] = DateTime.now().plus({ years: 4 }).year;
    this["start-year"] = DateTime.now().minus({ years: 96 }).year;
    this.placeholder = "";
    this["placeholder-mode"] = this.defaults.placeholderMode;
    this["placeholder-save"] = "Speichern";
    this["placeholder-cancel"] = "Schlie\xDFen";
    this._renderDialog = new RXController(
      this,
      merge(intrinsicHeight, timer(500)).pipe(
        map(() => this._shouldOpenDialog()),
        distinctUntilChanged()
      )
    );
    this.isDateBlocked = (date) => false;
    this.highlightedDate = (date) => false;
    this._dialogOpen = false;
    this._ignoreCurrentFocus = false;
    if (_DatePickerHeight === -1)
      getDatePickerHeight();
  }
  get inputToken() {
    return inputToken(this);
  }
  styles() {
    return [
      {
        ":host([error]) #trigger": { borderColor: this.colors.tone.error + " !important" }
      }
    ];
  }
  connectedCallback() {
    super.connectedCallback();
    this.setAttribute("tabindex", "0");
    fromEvent(this, "focus", { passive: true }).pipe(delay(0), takeUntil(this.disconnected)).subscribe(async () => {
      if (!this.disabled) {
        await new Promise((r) => setTimeout(r, 100));
        if (this._ignoreCurrentFocus)
          return this._ignoreCurrentFocus = false;
        if (!this.activated) {
          this.activated = true;
          await this.updateComplete;
        }
        this._renderDialog.value ? this._openDialog() : this._xdropdown?.open();
      }
    });
    fromEvent(this, "blur", { passive: true }).pipe(delay(0), takeUntil(this.disconnected)).subscribe(() => {
      const element = getActiveElement();
      const tippyParent = findParentOf(
        element,
        (e) => e instanceof HTMLElement && (e instanceof XDialog || e === this._dropdownContentElement || e.classList.contains("tippy-box") && e.getAttribute("role") === "tooltip")
      );
      if (tippyParent)
        return;
      if (this._renderDialog.value)
        return this._dialogReject?.();
      this._xdropdown?.close();
    });
    fromEvent(this, "keydown").pipe(takeUntil(this.disconnected)).subscribe((e) => {
      this._dropdownContentElement?.handleKeyDown(e);
    });
  }
  render() {
    if (!this.activated)
      return html` <x-flex> ${this._trigger()} </x-flex> `;
    return this._renderDialog.value ? this._dialog(this._trigger()) : this._dropdown(this._trigger());
  }
  _trigger() {
    const showLabel = !!this.placeholder && !!this.value.value || this.error;
    return xComponents(html`
      <x-flex
        slot="trigger"
        @click=${async () => {
      if (this.disabled)
        return;
      if (!this.activated) {
        this.activated = true;
        await this.updateComplete;
      }
      this._xdropdown?.open();
    }}
      >
        <x-formfield-wrapper
          ${injectAttributesOf(this, ["tabindex"])}
          ?show-label=${showLabel}
          one-line
          @cleared=${() => {
      this._ignoreCurrentFocus = true;
      this.value.next(null);
      this.dispatchEvent(new CustomEvent("value-picked", { detail: { value: null } }));
    }}
        >
          <x-text tone="${!this.value.value ? "placeholder" : ""}">
            ${this.value.value ? this["show-time"] ? this.value.value?.toLocaleString(DateTime.DATETIME_SHORT) : this.value.value?.toLocaleString(DateTime.DATE_SHORT) : this.placeholder || "Datum ausw\xE4hlen"}
          </x-text>
        </x-formfield-wrapper>
      </x-flex>
    `);
  }
  _dropdown(trigger) {
    return xComponents(html`
      <x-dropdown
        ?manual-close=${!this["click-to-save"] || this["show-time"]}
        @value-picked=${(e) => {
      if (e.detail.clickedDay)
        this._emitValue(e);
    }}
        @close-picker=${() => {
      this._ignoreCurrentFocus = true;
      this._xdropdown?.close();
    }}
        ${ref((dropdown) => this._xdropdown = dropdown)}
      >
        ${trigger}
        <x-date-picker-dropdown-content
          slot="dropdown-content"
          ${ref((e) => {
      this._dropdownContentElement = e;
      requestAnimationFrame(() => e?.focus());
    })}
          .date=${this.value.value || DateTime.now()}
          start-year=${this["start-year"]}
          end-year=${this["end-year"]}
          ?show-time=${this["show-time"]}
          ?click-to-save=${this["click-to-save"]}
          .isDateBlocked=${this.isDateBlocked}
          .highlightedDate=${this.highlightedDate}
          placeholder-save=${this["placeholder-save"]}
          placeholder-cancel=${this["placeholder-cancel"]}
        ></x-date-picker-dropdown-content>
      </x-dropdown>
    `);
  }
  _emitValue(e) {
    this.value.next(e.detail.value);
    this.dispatchEvent(new CustomEvent("date-picked", { detail: { value: e.detail.value } }));
    this.dispatchEvent(new CustomEvent("value-picked", { detail: { value: this.value.value } }));
  }
  _dialog(trigger) {
    return html` <x-flex @click=${() => this._openDialog()} ${css({ cursor: "pointer" })}> ${trigger} </x-flex> `;
  }
  _openDialog() {
    if (this._dialogOpen)
      return;
    this._dialogOpen = true;
    XDialog.showPopup({
      content: (resolve, reject) => {
        this._dialogReject = reject;
        return html`
          <x-date-picker-dropdown-content
            .useTrigger=${false}
            .date=${this.value.value || DateTime.now()}
            start-year=${this["start-year"]}
            end-year=${this["end-year"]}
            ?show-time=${this["show-time"]}
            ?click-to-save=${this["click-to-save"]}
            .isDateBlocked=${this.isDateBlocked}
            .highlightedDate=${this.highlightedDate}
            placeholder-save=${this["placeholder-save"]}
            placeholder-cancel=${this["placeholder-cancel"]}
            @value-picked=${(e) => {
          if (!e.detail.clickedDay)
            return;
          this._emitValue(e);
          resolve();
        }}
            @close-picker=${() => resolve()}
          ></x-date-picker-dropdown-content>
        `;
      }
    }).finally(() => this._dialogOpen = false);
  }
  _shouldOpenDialog() {
    return isMobile() || _DatePickerHeight > intrinsicHeight.getValue() * 0.45;
  }
};
__decorateClass([
  property({ type: Boolean })
], XDatePickerDropdown.prototype, "activated", 2);
__decorateClass([
  property({ type: Number })
], XDatePickerDropdown.prototype, "end-year", 2);
__decorateClass([
  property({ type: Number })
], XDatePickerDropdown.prototype, "start-year", 2);
__decorateClass([
  property({ type: Boolean })
], XDatePickerDropdown.prototype, "show-time", 2);
__decorateClass([
  property()
], XDatePickerDropdown.prototype, "placeholder", 2);
__decorateClass([
  property()
], XDatePickerDropdown.prototype, "placeholder-mode", 2);
__decorateClass([
  property({ type: Boolean })
], XDatePickerDropdown.prototype, "click-to-save", 2);
__decorateClass([
  property({ type: Boolean })
], XDatePickerDropdown.prototype, "clearable", 2);
__decorateClass([
  property()
], XDatePickerDropdown.prototype, "placeholder-save", 2);
__decorateClass([
  property()
], XDatePickerDropdown.prototype, "placeholder-cancel", 2);
__decorateClass([
  state()
], XDatePickerDropdown.prototype, "_renderDialog", 2);
XDatePickerDropdown = __decorateClass([
  customElement("x-date-picker-dropdown")
], XDatePickerDropdown);
var XDatePickerDropdownContent = class extends ChemistryLitElement {
  constructor() {
    super(...arguments);
    this["end-year"] = DateTime.now().plus({ years: 4 }).year;
    this["start-year"] = DateTime.now().minus({ years: 96 }).year;
    this.date = DateTime.now();
    this.useTrigger = true;
    this["placeholder-save"] = "Speichern";
    this["placeholder-cancel"] = "Schlie\xDFen";
    this.isDateBlocked = (date) => false;
    this.highlightedDate = (date) => false;
    this._datePicker = createRef();
  }
  receiveTrigger(trigger) {
    this._trigger = trigger;
  }
  handleKeyDown(event) {
    this._datePicker.value?.handleKeyDown(event);
  }
  focus() {
    this._datePicker.value?.focus();
  }
  firstUpdated() {
    if (!this.useTrigger)
      requestAnimationFrame(() => this.focus());
  }
  render() {
    const canSaveWithClick = this["click-to-save"] && !this["show-time"];
    return xComponents(html`
      <x-basic-card padding="sm" space="md">
        <x-basic-date-picker
          ${ref(this._datePicker)}
          ._showPending=${true}
          .value=${this.date}
          .isDateBlocked=${this.isDateBlocked}
          .highlightedDate=${this.highlightedDate}
          start-year=${this["start-year"]}
          end-year=${this["end-year"]}
          @value-picked=${async (e) => {
      this.date = e.detail.value;
      if (canSaveWithClick) {
        requestAnimationFrame(() => this._emitValue(e.detail.value, e.detail.clickedDay));
      }
    }}
          @escape=${() => this.dispatchEvent(new CustomEvent("close-picker"))}
        ></x-basic-date-picker>
        ${this["show-time"] ? html`
              <x-input
                type="time"
                @value-changed=${(e) => {
      if (this.date.hour !== e.detail.value.hour || this.date.minute !== e.detail.value.minute) {
        this.date = this.date.set({ hour: e.detail.value.hour, minute: e.detail.value.minute });
      }
    }}
                .value=${this.date}
              ></x-input>
            ` : nothing}
        ${!canSaveWithClick ? html`
              <x-flex horizontal space-between space="md">
                <x-button
                  mode="outline"
                  @click=${() => {
      this.dispatchEvent(new CustomEvent("close-picker"));
    }}
                >
                  ${this["placeholder-cancel"]}
                </x-button>
                <x-button @click=${() => this._emitValue(this.date, true)}> ${this["placeholder-save"]} </x-button>
              </x-flex>
            ` : nothing}
      </x-basic-card>
    `);
  }
  _emitValue(date, clickedDay) {
    this.dispatchEvent(new CustomEvent("value-picked", { detail: { value: date, clickedDay } }));
    if (this.useTrigger) {
      if (clickedDay)
        this._trigger?.toggle();
      return;
    }
  }
  dispatchEvent(event) {
    if (this.useTrigger)
      return !!this._trigger?.dispatchEvent(event);
    return super.dispatchEvent(event);
  }
};
__decorateClass([
  property({ type: Number })
], XDatePickerDropdownContent.prototype, "end-year", 2);
__decorateClass([
  property({ type: Number })
], XDatePickerDropdownContent.prototype, "start-year", 2);
__decorateClass([
  state()
], XDatePickerDropdownContent.prototype, "date", 2);
__decorateClass([
  property({ type: Boolean })
], XDatePickerDropdownContent.prototype, "show-time", 2);
__decorateClass([
  property({ type: Boolean })
], XDatePickerDropdownContent.prototype, "click-to-save", 2);
__decorateClass([
  state()
], XDatePickerDropdownContent.prototype, "useTrigger", 2);
__decorateClass([
  property()
], XDatePickerDropdownContent.prototype, "placeholder-save", 2);
__decorateClass([
  property()
], XDatePickerDropdownContent.prototype, "placeholder-cancel", 2);
XDatePickerDropdownContent = __decorateClass([
  customElement("x-date-picker-dropdown-content")
], XDatePickerDropdownContent);
var _DatePickerHeight = -1;
var _DatePickerHeightPending = false;
var getDatePickerHeight = async () => {
  if (_DatePickerHeightPending)
    return;
  _DatePickerHeightPending = true;
  const dropdown = document.createElement(
    `${DesignSystem.prefix}-date-picker-dropdown-content`
  );
  dropdown["show-time"] = true;
  dropdown["click-to-save"] = true;
  dropdown.style.setProperty("position", "fixed");
  dropdown.style.setProperty("top", "-1000px");
  dropdown.style.setProperty("left", "-1000px");
  dropdown.style.setProperty("opacity", "0");
  dropdown.style.setProperty("pointer-events", "none");
  document.body.appendChild(dropdown);
  await dropdown.updateComplete;
  await new Promise((r) => requestAnimationFrame(r));
  _DatePickerHeight = dropdown.offsetHeight;
  document.body.removeChild(dropdown);
};
export {
  XDatePickerDropdown,
  XDatePickerDropdownContent
};
